import React, {Component} from "react";

class HostNotes_MultiWindow extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        let currentNote = false;
        const notes = [...this.props.state.Notes_Alerts, this.props.state.Notes_CurrentActivity, ...this.props.state.Notes_Callouts];
        if ( //notes[0].payload !== 'null' &&
            notes[0].payload !== '') {
            currentNote = notes[0]
        } else if (notes.length > 1) {
            currentNote = notes[1]
        }
        //console.log('MOHIT',{notes})
		if (currentNote.type == "activity" )
			{
				currentNote.type = 'note';
			}
		
        return currentNote !== false && this.props.state.sessionStartedByHost ? (
            <div className={"note --type-"+currentNote.type} >
                <div className={'alertH1D2C'}>{currentNote.type[0].toUpperCase() + currentNote.type.slice(1)}: <span className="alertTextD2C"> {currentNote.payload}</span></div>
            </div>) : null;
    }
}

export default HostNotes_MultiWindow;